export const GROUP_DELETE_RESET = 'GROUP_DELETE_RESET'
export const GROUP_DELETE_SET_ERROR = 'GROUP_DELETE_SET_ERROR'
export const GROUP_DELETE_SET_DELETED = 'GROUP_DELETE_SET_DELETED'
export const GROUP_DELETE_TOGGLE_LOADING = 'GROUP_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/group/delete/mutation_types.js